import {installConsoleErrorBuffer} from "./consoleErrorBuffer";

// A module of its own, imported first by main.tsx: imports are hoisted, so a
// call in main.tsx's body would run only after every other module had
// already been evaluated, and miss what they throw (#1285).
installConsoleErrorBuffer();
